(function () {
    'use strict';

    const CONFIG = {
        debug: false,
    };

    function debugLog(message, data = null) {
        if (CONFIG.debug) {
            console.log('[LDT Custom]', message, data || '');
        }
    }

    const coursePath = '/apps/cursos/course/'
    let currentUrl = window.location.href;
    let isInitialized = false;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

    function initialize() {
        if (isInitialized) return;
        debugLog('Script customizado LDT inicializado');

        if (window.location.pathname.includes(coursePath)) {
            replaceCourseContent()
        } else {
            debugLog('URL não corresponde a uma página de curso');
        }

        setupUrlMonitoring();
        isInitialized = true;
    }

    function setupUrlMonitoring() {
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        history.pushState = function () {
            originalPushState.apply(history, arguments);
            handleUrlChange();
        };

        history.replaceState = function () {
            originalReplaceState.apply(history, arguments);
            handleUrlChange();
        };

        window.addEventListener('popstate', handleUrlChange);

        const observer = new MutationObserver(function (mutations) {
            let shouldCheck = false;

            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' || mutation.type === 'subtree') {
                    shouldCheck = true;
                }
            });

            if (shouldCheck) {
                debugLog('Mudanças detectadas no DOM, verificando necessidade de reinicialização');
                handleUrlChange()
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        debugLog('Monitoramento de URL configurado');
    }

    function handleUrlChange() {
        if (!window.location.pathname.includes(coursePath)) return;

        const newUrl = window.location.href;

        if (newUrl !== currentUrl) {
            debugLog('Mudança de URL detectada:', {
                old: currentUrl,
                new: newUrl,
            });

            replaceCourseContent()

            currentUrl = newUrl;
        }
    }

    async function replaceCourseContent() {
        debugLog('Iniciando atualização do conteúdo');

        const courseData = await getCourseData();

        if (!courseData) {
            debugLog('courseData não encontrado');
            return;
        }

        replaceHeroContent(courseData);
        replaceLessonHeaderContent(courseData)
    }

    async function replaceHeroContent(courseData) {
        const container = await waitForElement('.ldt-cr-course-info');
        const newContentContainer = document.querySelector('.ldt-custom__container');

        if (!container || newContentContainer) return;

        const image = document.querySelector('.ldt-cr-course-featured-image img');

        const siblingDiv = document.createElement('div');
        siblingDiv.className = 'ldt-custom__container';
        container.parentNode.insertBefore(siblingDiv, container.nextSibling);
        container.style.display = 'none';

        const clonedImage = image ? image.cloneNode(true) : null;
        if (clonedImage) {
            clonedImage.className = 'ldt-custom__image';
        }

        let newContent = `
        <div class="ldt-custom">
            <p>Curso</p>
            <div class="ldt-custom__title">
                <h1>${courseData.title}</h1>
                <h2 class="ldt-custom__authors">
                    <span>com</span>
                    ${courseData.authors}
                </h2>
            </div>
            <div class="ldt-custom__image-container">
                ${clonedImage.outerHTML}
            </div>
            <div class="ldt-custom__summary h4">
                ${courseData.summary}
            </div>
        </div>
    `;

        siblingDiv.innerHTML = newContent;
    }

    async function replaceLessonHeaderContent(courseData) {
        debugLog('Atualização conteúdo aula iniciada');

        const lessonTitleContainer = await waitForElement('.ldt-cr-course-content-detail .ldt-cr-card-title');
        const lessonTitle = lessonTitleContainer.querySelector('.ldt-cr-course-content-detail .ldt-cr-card-title-value');

        if (!lessonTitle) {
            debugLog('Título da aula não encontrado');
            return;
        }

        let siblingDiv = null;
        siblingDiv = document.querySelector('.ldt-custom__lesson') || siblingDiv;

        if (siblingDiv) {
            debugLog('Container para o conteúdo da aula já existe' + siblingDiv);
        } else {
            debugLog('Criando novo container para o conteúdo da aula');

            siblingDiv = document.createElement('div');
            siblingDiv.className = 'ldt-custom__lesson';
            lessonTitleContainer.parentNode.insertBefore(siblingDiv, lessonTitleContainer.nextSibling);
            lessonTitleContainer.style.display = 'none';
        }

        const lessonTitleParts = lessonTitle.innerText.split(/\s*[-–—]\s*/);
        const lessonTitleText = lessonTitleParts.length > 1 ? lessonTitleParts[1] : '';
        const lessonNumberText = lessonTitleParts.length > 1 ? lessonTitleParts[0] : lessonTitle.innerText;;

        let lessonSummary = '';
        if (courseData.lessons && Array.isArray(courseData.lessons)) {
            const index = courseData.lessons.findIndex(l => l.title === lessonTitleText);
            const lesson = courseData.lessons.find(l => l.title === lessonTitleText);
            lessonSummary = lesson ? lesson.summary : '';
        }

        let newContent = `
            <div class="ldt-custom__lesson-title">
                <span>${lessonNumberText}</span>
                <h2>${lessonTitleText}</h2>
            </div>
            <div class="ldt-custom__lesson-summary h5">
                ${lessonSummary}
            </div>
    `;

        siblingDiv.innerHTML = newContent;

        siblingDiv = null;
        lessonSummary = '';
        debugLog('Conteúdo aula atualizado');
    }

    async function waitForElement(selector) {
        return new Promise(resolve => {
            const el = document.querySelector(selector);
            if (el) return resolve(el);
            const observer = new MutationObserver(() => {
                const el = document.querySelector(selector);
                if (el) {
                    observer.disconnect();
                    resolve(el);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }

    async function getCourseData() {
        try {
            const productHandle = await getProductHandle();
            if (!productHandle) return;

            return window.LDT_COURSE_METAFIELDS[productHandle];
        } catch (error) {
            console.error(productHandle, error);
        }
    }

    async function getProductHandle() {
        const courseId = window.location.pathname.split(coursePath)[1].split('/')[0];
        if (!courseId) return null;

        const url = `https://editora-ayine.myshopify.com/apps/cursos/api/course/${courseId}?lang=pt-BR`;

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            return data.products[0].handle;
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
})();